import type { AiChatProduct, EventData } from '../types'

import { EVENT_PLATFORM } from './constants'
import { aiChatProductModel } from './models/aiChatProduct'
import { brazeFavoriteTrackingModel } from './models/favorites'
import { productModel } from './models/product'

import { addToCustomAttributeArray, sendEvent, setCustomUserAttribute } from '.'

export function trackSearchTerm(query: string) {
  const eventName = 'search_term'
  const payload = {
    event_platform: EVENT_PLATFORM,
    search_term: query,
  }

  sendEvent(eventName, payload)
}

export function trackBuybackDeviceSpecifications(data: EventData) {
  const eventName = 'buybackDeviceSpecifications'
  sendEvent(eventName, data)
}

export function trackProduct(product: EventData) {
  const eventName = 'product'
  const payload = {
    ...productModel(product),
    event_platform: EVENT_PLATFORM,
  }

  sendEvent(eventName, payload)
}

export function trackAddToMyFavorites(favorite: EventData) {
  const eventName = 'added_to_favorites'
  const payload = {
    ...brazeFavoriteTrackingModel(favorite),
    event_platform: EVENT_PLATFORM,
  }

  sendEvent(eventName, payload)
}

export function trackFavoritesPage({ favorites }: { favorites: EventData[] }) {
  const eventName = 'favorites_page_viewed'
  const payload = {
    number_of_items_on_list: favorites.length,
    event_platform: EVENT_PLATFORM,
  }

  sendEvent(eventName, payload)
}

export function trackAddToCart(product: EventData) {
  const eventName = 'add_to_cart'
  const payload = {
    ...productModel(product),
    event_platform: EVENT_PLATFORM,
  }

  sendEvent(eventName, payload)
}

export function trackBuyBackPlayStationPartnership() {
  const eventName = 'buyback_creation_playstation'

  sendEvent(eventName, {})
}

export function trackRecyclingOrder() {
  const eventName = 'recycling_created'

  sendEvent(eventName, {})
}

// Shopping assistant custom events
export function trackShoppingAssistantChatReady(payload: EventData) {
  sendEvent('ai_chat_started', { chat_id: payload.chatId })

  if (payload.chatId) {
    addToCustomAttributeArray('ai_chat_ids', payload.chatId.toString())
  }
}

export function trackShoppingAssistantProductClick({
  product,
  chatId,
}: {
  product: AiChatProduct
  chatId: string
}) {
  const formattedProduct = aiChatProductModel(product)

  sendEvent('ai_chat_product_clicked', {
    ...formattedProduct,
    chat_id: chatId,
  })

  setCustomUserAttribute('ai_chat_product_clicked', formattedProduct)

  if (formattedProduct.object_id) {
    addToCustomAttributeArray(
      'ai_chat_product_clicked',
      formattedProduct.object_id.toString(),
    )
  }

  if (formattedProduct.product_category) {
    addToCustomAttributeArray(
      'ai_chat_product_categories_clicked',
      formattedProduct.product_category.toString(),
    )
  }
}

export function trackShoppingAssistantProductRecommendationReceived({
  products,
}: {
  products: AiChatProduct[]
}) {
  const formattedProducts = products.map(aiChatProductModel)

  setCustomUserAttribute('ai_chat_product_discussed', formattedProducts)
}

export function trackShoppingAssistantMessageSent(payload: EventData) {
  const { chatId, inputMethod } = payload

  sendEvent('ai_chat_message_sent', {
    chat_id: chatId,
    input_method: inputMethod,
  })
}
